import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { AddressService } from '../address/address.service';
import { AppComponent } from '../app.component';
import { empty } from '../helpers';
import { Individual } from '../model/individual';
import { WizardStep } from '../wizard-step';
import { WizardService } from '../wizard/wizard.service';
import { WizardNavigationService } from '../wizard/wizard-navigation.service';
import { map, take } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable, ReplaySubject, Subject } from 'rxjs';
import { AppSettings } from 'pac-api';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.css']
})
export class ContactInfoComponent implements OnInit, WizardStep {

  static readonly Name = 'ContactInfoComponent';
  readonly Name = 'ContactInfoComponent';

  private _isSaving: boolean;
  individual: Individual;
  form: UntypedFormGroup;

  public get isSaving(): boolean {
    return this._isSaving;
  }

  public set isSaving(value: boolean) {
    this._isSaving = value;
    this.app.wait(value);
  }

  public CanSkip$: Subject<boolean> = new ReplaySubject(1);

  @Output()
  OnSave: EventEmitter<Individual> = new EventEmitter<Individual>();

  get existing(): boolean {
    if (this.individual.cst_recno && this.individual.cst_key) {
      return true;
    } else {
      return false;
    }
  }

  constructor(
    private wizard: WizardService,
    public settings: AppSettings,
    private navigation: WizardNavigationService,
    private address: AddressService,
    private changeDetector: ChangeDetectorRef,
    private app: AppComponent,
    private route: ActivatedRoute
  ) {
    this.isSaving = false;
    this.form = new UntypedFormGroup({});
    this.individual = this.wizard.getIndividual();

    combineLatest([route.paramMap, route.data]).pipe(
      take(1)
    ).subscribe(([param, data]) => {
      if (param.has('email') && !this.existing) {
        this.individual.eml_address = param.get('email');
      }

      if (data.ind_mblex_date_ext && !this.individual.ind_mblex_date_ext) {
        this.individual.ind_mblex_date_ext = data.ind_mblex_date_ext;
        this.CanSkip$.next(false);
      } else if (this.existing) {
        this.CanSkip$.next(true);
      }
    });

    if (!empty(this.individual.cst_key) && !empty(this.individual.cst_recno)) {
      if (! empty(this.individual.cxa_key)) {
        if (this.wizard.Address === null) {
          this.wizard.Address = this.address.GetAddress(this.individual.cxa_key);
          this.wizard.Address.subscribe(adr => {
            this.wizard.setAddress(adr);
          });
        }
      }
    }
  }

  ngOnInit() {
  }

  OnSubmit(individual: Individual) {
    if (this.form.valid) {
      this.isSaving = true;

      this.OnSave.emit(this.individual);
      this.wizard.setIndiviudal(this.individual);

      this.changeDetector.detectChanges();

      if (this.existing) {
        this.wizard.UpdateAccount().subscribe(result => {
          this.navigation.next(this, this.route);
        });
      } else {
        this.wizard.CreateAccount(this.form.value.recaptcha.gRecaptchaResponse).subscribe(result => {
          this.navigation.next(this, this.route);
        });
      }
    }
  }

  ready(): boolean {
    return this.form.valid;
  }

  skip() {
    if (this.existing) {
      this.navigation.skip(this, this.route);
    }
  }

}
